export const KEY_LOADING = {
  CREATE_HISTORY: 'createHistory',
};
